import http from '../../../assets/extra/_httpServices';
import { updateLoadingScreen } from '../../../redux/Actions';
import { urls } from '../../../components/common/constants';
import * as types from './MasterActionType'

const counters_filter = (data) => {
    return {
        type: types.COUNTERS_FILTER,
        payload: data,
    }
}
const busStation_List = (data) => {
    return {
        type: types.BUSSTATION_LIST,
        payload: data,
    }
}
const auditModule_List = (data) => {
    return {
        type: types.AUDIT_MODULE_LIST,
        payload: data,
    }
}
const place_List = (data) => {
    return {
        type: types.PLACE_LIST,
        payload: data,
    }
}
const city_Cargo_List = (data) => {
    return {
        type: types.CITY_CARGO_LIST,
        payload: data,
    }
}
const UpdateMasterCodeList = (data) => {
    return {
        type: types.UPDATE_MASTER_CODE_LIST,
        payload: data,
    }
}

const updateStatesListAll = (data) => {
    return {
        type: types.STATES_LIST,
        payload: data,
    }
}

const updateStatesTableData = (data) => {
    return {
        type: types.STATES_TBL_DATA,
        payload: data,
    }
}

const updateCrewFilter = (data) => {
    return {
        type: types.CREW_LIST,
        payload: data,
    }
}
const updateDepotList = (data) => {
    return {
        type: types.DEPOT_LIST,
        payload: data,
    }
}

const updateDivFilter = (data) => {
    return {
        type: types.DIVISION_LIST,
        payload: data,
    }
}
const updateCorporationList = (data) => {
    return {
        type: types.CORPORATION_LIST,
        payload: data,
    }
}
const updateClassTypeList = (data) => {
    return {
        type: types.CLASS_TYPE_LIST,
        payload: data,
    }
}
const updateClassTypeMasterList = (data) => {
    return {
        type: types.CLASS_TYPE_MASTER_LIST,
        payload: data,
    }
}

const updateCorporationListAll = (data) => {
    return {
        type: types.CORPORATION_LIST,
        payload: data,
    }
}
const updateCorporationTableData = (data) => {
    return {
        type: types.CORPORATION_TBL_DATA,
        payload: data,
    }
}
const updateLeviesListAll = (data) => {
    return {
        type: types.LEVIES_LIST_DATA,
        payload: data,
    }
}
const updateCorpLeviesListAll = (data) => {
    return {
        type: types.LEVIES_CORP_LIST_DATA,
        payload: data,
    }
}
const updateLeviesTableData = (data) => {
    return {
        type: types.LEVIES_TBL_DATA,
        payload: data,
    }
}
const updateConcessionListAll = (data) => {
    return {
        type: types.CONCESSION_LIST,
        payload: data,
    }
}
const updateConcessionTableData = (data) => {
    return {
        type: types.CONCESSION_TBL_DATA,
        payload: data,
    }
}

const place_TableData = (data) => {
    return {
        type: types.PLACE_TABLEDATA,
        payload: data,
    }
}
const updateVehicleMacList = (data) => {
    return {
        type: types.VEHICLE_MAC,
        payload: data,
    }
}
const updateGroupDiscountList = (data) => {
    return {
        type: types.GROUP_DISCOUNT_LIST,
        payload: data,
    }
}
const updateClassTypeLevyList = (data) => {
    return {
        type: types.CLASS_TYPE_LEVY_LIST,
        payload: data,
    }
}
const updateSeasonTypeList = (data) => {
    return {
        type: types.SEASON_TYPE_LIST,
        payload: data,
    }
}
const updatePaymentGatewayList = (data) => {
    return {
        type: types.PAYMENTGATEWAY_LIST,
        payload: data,
    }
}
export const CountersfilterList = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getMasterCountersListAll, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(counters_filter(response.data.Data.Table));
                } else {
                    dispatch(counters_filter([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(counters_filter([]))
            })
    }
}

export const getBusStationListAll = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        http.GetRequestCached(urls?.getBusStationListAll, params, isCache, cacheDuration)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(busStation_List(response.data.Data.Table));
                } else {
                    dispatch(busStation_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(busStation_List([]))
            })
    }
}

export const getplaceListAll = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getplaceListAll, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(place_List(response.data.Data.Table));
                } else {
                    dispatch(place_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(place_List([]))
            })
    }
}
export const getCityCargoList = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getCargoCityList, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    let newData = response?.data?.Data?.Table?.map((val) => ({ ...val, ActualCityName: `${val.CityName} (${val.CityShortName})` }))
                    .sort((a, b) => a.CityName.localeCompare(b.CityName));
                    dispatch(city_Cargo_List(newData));
                } else {
                    dispatch(city_Cargo_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(city_Cargo_List([]))
            })
    }
}

export const getCounterTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getMasterCountersListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}
export const getStatesTableData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getStatesList, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateStatesTableData(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateStatesTableData([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateStatesTableData([]));
            });
    };
};
export const getStatesListData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getStatesList, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateStatesListAll(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateStatesListAll([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateStatesListAll([]));
            });
    };
};
export const statesInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getStatesInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const statesDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getStatesDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const counterDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.counterDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const counterInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.counterInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


//for crew

export const CrewfilterList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getCrewListAll, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateCrewFilter(response.data.Data.Table));
                } else {
                    dispatch(updateCrewFilter([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateCrewFilter([]))
            })
    }
}

export const getDepotList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getDepotList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateDepotList(response.data.Data.Table));
                } else {
                    dispatch(updateDepotList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateDepotList([]))
            })
    }
}


export const getCrewTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getCrewListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}


export const crewDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.crewDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const crewInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.crewInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


//for Division

export const divisionFilterList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getdivisionFilterList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateDivFilter(response.data.Data.Table));
                } else {
                    dispatch(updateDivFilter([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateDivFilter([]))
            })
    }
}

export const getDivTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getdivisionFilterList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const divisionDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.divisionDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCorporationList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getCorporationList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateCorporationList(response.data.Data.Table));
                } else {
                    dispatch(updateCorporationList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateCorporationList([]))
            })
    }
}
export const getCorporationListData = (body, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .GetRequestCached(urls?.getCorporationList, body, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateCorporationListAll(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateCorporationListAll([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateCorporationListAll([]));
            });
    };
};
export const divisionInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.divisionInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


// for depot
export const depotInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.depotInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const depotDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.depotDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDepotTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getDepotList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}


export const getBusStattionTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getBusStationListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const getConcessionListAll = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getCorpConcessionList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const busStationInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.busStationInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const busStationDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.busStationDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getClassTypeList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getClassTypeList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateClassTypeList(response.data.Data.Table));
                } else {
                    dispatch(updateClassTypeList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateClassTypeList([]))
            })
    }
}

export const getClassTypeMasterList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getClassTypeMasterList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateClassTypeMasterList(response.data.Data.Table));
                } else {
                    dispatch(updateClassTypeMasterList([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateClassTypeMasterList([]))
            })
    }
}


export const classTypeInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.classTypeInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const classTypeDetailsDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.classTypeDetailsDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const classTypeDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.classTypeDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getClassTypeTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getClassTypeList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const getLeviesListAll = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getLeviesListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}
export const getConcessionTypesListAll = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getConcessionTypesListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}















export const getCorporationTableData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getCorporationList, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateCorporationTableData(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateCorporationTableData([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateCorporationTableData([]));
            });
    };
};

export const corporationInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getCorporationInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const corporationInactive = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorporationInActive, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCorpLeviesListAllData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getCorporationLeviesListAll, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateCorpLeviesListAll(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateCorpLeviesListAll([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateCorpLeviesListAll([]));
            });
    };
};
export const getLeviesListAllData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getLeviesListAll, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateLeviesListAll(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateLeviesListAll([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateLeviesListAll([]));
            });
    };
};
export const getLeviesListTableData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getCorporationLeviesListAll, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateLeviesTableData(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateLeviesTableData([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateLeviesTableData([]));
            });
    };
};

export const getLeviesDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getLeviesDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const leviesInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getLeviesInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const placesInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getPlacesInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const placesTableData = (params) => (dispatch) => {
    dispatch(updateLoadingScreen(true))
    http.HttpGet(urls?.getplaceListAll, params)
        .then((response) => {
            if (response.status === 200 && response.data.status) {
                dispatch(place_TableData(response.data.Data));
                dispatch(updateLoadingScreen(false))
            } else {
                dispatch(place_TableData([]));
                dispatch(updateLoadingScreen(false))
            }
        })
        .catch((error) => {
            console.log("Error: ", error);
            dispatch(place_TableData([]))
            dispatch(updateLoadingScreen(false))
        })
}
export const placesEditData = (params) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getplaceListAll, params)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const placesDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.gePlaceDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getConcessionListData = (body, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .GetRequestCached(urls?.getConcessionListAll, body, isCache = false, cacheDuration = 0)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateConcessionListAll(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateConcessionListAll([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateConcessionListAll([]));
            });
    };
};

export const getConcessionTableData = (body) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getCorpConcessionList, body)
            .then((response) => {
                dispatch(updateLoadingScreen(false));
                if (response?.status === 200) {
                    dispatch(updateConcessionTableData(response?.data?.Data?.Table || []));
                } else {
                    dispatch(updateConcessionTableData([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateConcessionTableData([]));
            });
    };
};

export const getConcessionDetailsTableData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorpConcessionList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const concessionInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getCorpConcessionInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getConcessionDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorpConcessionDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getConcessionDetailsDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorpConcessionDetailsDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getVehicleMasterTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getVehicleMasterTableData, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}
export const getCompanyChartsListAll = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getCompanyChartsListAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const getVehicleMacList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getVehicleMacList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateVehicleMacList(response.data.Data.Table));
                } else {
                    dispatch(updateVehicleMacList([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateVehicleMacList([]))
            })
    }
}
export const getCompanyChartsGetChartLayout = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.CompanyChartsGetChartLayout, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const BusesInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.BusesInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGroupDiscountTableData = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getGroupDiscountData, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateGroupDiscountList(response.data.Data.Table));
                } else {
                    dispatch(updateGroupDiscountList([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateGroupDiscountList([]))
            })
    }
}
export const groupDiscountInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.groupDiscountInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getClassTypeLeviesList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getClassTypeList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateClassTypeLevyList(response.data.Data.Table1));
                } else {
                    dispatch(updateClassTypeLevyList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateClassTypeLevyList([]))
            })
    }
}

export const getSeasonTypeList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getClassTypeMasterList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateSeasonTypeList(response.data.Data.Table2));
                } else {
                    dispatch(updateSeasonTypeList([]));
                }
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                console.log("Error: ", error);
                dispatch(updateSeasonTypeList([]))
            })
    }
}
export const getModuleListAll = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getModuleListAll, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(auditModule_List(response.data.Data.Table));
                } else {
                    dispatch(auditModule_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(auditModule_List([]))
            })
    }
}

export const getMasterCodeList = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getMasterCode, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(UpdateMasterCodeList(response.data.Data.Table));
                } else {
                    dispatch(UpdateMasterCodeList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(UpdateMasterCodeList([]))
            })
    }
}

export const getMasterCode = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getMasterCode, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}
export const MasterCodeInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.MasterCodeInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getMasterCodeSessionList = (params) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls?.getMasterCode, params)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getPaymentGatewayList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getPaymentGatewayList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updatePaymentGatewayList(response.data.Data.Table));
                } else {
                    dispatch(updatePaymentGatewayList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updatePaymentGatewayList([]))
            })
    }
}
export const getLinkPlaceList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getLinkPlace, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const LinkPlaceInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.getLinkPlaceInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}